import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { ToastrService } from 'ngx-toastr';
import { IBaseModel } from 'src/app/models/base.model';
import { ITipoDispensaModel } from 'src/app/models/tipo-dispensa.model';
import { TipoDispensaService } from 'src/app/services/tipo-dispensa.service';
import { BaseFormComponent } from '../../shared/components/base-form/base-form.component';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-tipo-dispensa-form',
  templateUrl: './tipo-dispensa-form.component.html',
  styleUrls: ['./tipo-dispensa-form.component.scss']
})
export class TipoDispensaFormComponent extends BaseFormComponent implements OnInit {
  public model: ITipoDispensaModel = {} as ITipoDispensaModel;

  public form = new FormGroup({
    id: new FormControl({ value: '', disabled: true }),
    nome: new FormControl('', Validators.required),
    descricao: new FormControl('', Validators.required),
    quantidadeDiasPadrao: new FormControl(null, Validators.required),
  });

  constructor(
    route: ActivatedRoute,
    toastr: ToastrService,
    router: Router,
    localeService: BsLocaleService,
    private tipoDispensaService: TipoDispensaService,
    public matDialog: MatDialog
  ) {
    super(route, toastr,  router, localeService, matDialog);

    if (this.novoRegistro) {
      this.titulo = 'Novo Tipo de Dispensa';
    } 
  }

  async ngOnInit() {

    try {
      if (!this.novoRegistro) {
        const res = await this.tipoDispensaService.obterPorId(this.id);
        if (res.sucesso) {
          this.model = res.dados;
          if (this.visualizar){
            this.titulo = 'Visualizar Tipo de Dispensa - ' + this.model.nome;
          }
          else {
            this.titulo = 'Editar Tipo de Dispensa - ' + this.model.nome;
          }

        } else {
          Swal.fire({
            toast: true,
            position: 'top-end',
            icon: 'error',
            text: res.mensagem.descricao,
            showConfirmButton: false,
            timer: 5000,
            timerProgressBar: true,
          });
          this.router.navigate(['/tipos-dispensa']);
          return;
        }
      }

      this.form.patchValue(this.model);
    } catch (err) {
      Swal.fire({
        toast: true,
        position: 'top-end',
        icon: 'error',
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
      });
      this.router.navigate(['/tipos-dispensa']);
    }
  }

  public async onSubmit() {
    if (this.form.invalid) {
      this.exibirMensagemAlerta('Formulário inválido');
      return;
    }
    this.submit = true;

    this.atualizarModel(this.form.value);

    try {
      let res: IBaseModel<void> = null;

      if (!this.novoRegistro) {
        res = await this.tipoDispensaService.atualizar(this.model);
      } else {
        res = await this.tipoDispensaService.inserir(this.model);
      }

      if (res.sucesso) {
        Swal.fire({
          toast: true,
          position: 'top-end',
          icon: 'success',
          text: res.mensagem.descricao,
          showConfirmButton: false,
          timer: 5000,
          timerProgressBar: true,
        });
        this.router.navigate(['/tipos-dispensa']);
      } else {
        const validacoes = this.montarMensagensValidacao(res);
        this.exibirMensagemAlerta(res.mensagem.descricao);
      }
    } catch (err) {
      Swal.fire({
        toast: true,
        position: 'top-end',
        icon: 'error',
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
      });
    } 
  }

  private atualizarModel(values: any) {
    Object.assign(this.model, values);
  }

  public onBack() {
    this.router.navigate(['/tipos-dispensa']);
  }
  
  public cancelar() {
    this.router.navigate(['/tipos-dispensa']);
  }
}
